import type { TermsPolicy } from '@/types';

interface PolicyHeaderProps {
  termsPolicy: TermsPolicy | null;
  className?: string;
}

export function PolicyHeader({ termsPolicy, className = '' }: PolicyHeaderProps) {
  
  if (!termsPolicy) {
    return (
      <div className={`text-center mb-8 ${className}`}>
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-gray-200 rounded w-1/2 mx-auto"></div>
          <div className="h-4 bg-gray-200 rounded w-1/3 mx-auto"></div>
        </div>
      </div>
    );
  }

  return (
    <div className={`text-center mb-8 ${className}`}>
      <h1 className="text-[28px] font-bold text-[#222222] mb-4">
        {termsPolicy.title}
      </h1>
      
      {/* 메타 정보 */}
      <div className="flex justify-center items-center space-x-4 text-[14px] text-gray-500">
        {termsPolicy.version && (
          <span>버전 {termsPolicy.version}</span>
        )}
        {termsPolicy.created_at && (
          <>
            <span>•</span>
            <span>
              생성일: {new Date(termsPolicy.created_at).toLocaleDateString('ko-KR')}
            </span>
          </>
        )}
        {termsPolicy.updated_at && (
          <>
            <span>•</span>
            <span>
              최종 수정: {new Date(termsPolicy.updated_at).toLocaleDateString('ko-KR')}
            </span>
          </>
        )}
      </div>
    </div>
  );
}